import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Catalogo from './pages/Catalogo';
import ProdutoPage from './pages/ProdutoPage';
import { useLenis } from './hooks/useLenis';
import { AuthProvider, useAuth } from './admin/AuthContext';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import Dashboard from './admin/Dashboard';
import ProdutosList from './admin/ProdutosList';
import ProdutoForm from './admin/ProdutoForm';
import Estoque from './admin/Estoque';
import Categorias from './admin/Categorias';
import Configuracoes from './admin/Configuracoes';
import Destaques from './admin/Destaques';
import Promocoes from './admin/Promocoes';
import Banners from './admin/Banners';
import Personalizar from './admin/Personalizar';
import Identidade from './admin/Identidade';
import Compartilhar from './admin/Compartilhar';
import './App.css';

function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div data-testid="admin-loading" className="flex min-h-screen items-center justify-center bg-slate-100">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-mk-blue border-t-transparent" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
}

export default function App() {
  useLenis();
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Catalogo />} />
          <Route path="/produto/:id" element={<ProdutoPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="produtos" element={<ProdutosList />} />
            <Route path="produtos/novo" element={<ProdutoForm />} />
            <Route path="produtos/:id" element={<ProdutoForm />} />
            <Route path="estoque" element={<Estoque />} />
            <Route path="categorias" element={<Categorias />} />
            <Route path="destaques" element={<Destaques />} />
            <Route path="promocoes" element={<Promocoes />} />
            <Route path="banners" element={<Banners />} />
            <Route path="personalizar" element={<Personalizar />} />
            <Route path="identidade" element={<Identidade />} />
            <Route path="compartilhar" element={<Compartilhar />} />
            <Route path="configuracoes" element={<Configuracoes />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
